var p = Object.defineProperty;
var C = (t, n, o) => n in t ? p(t, n, { enumerable: !0, configurable: !0, writable: !0, value: o }) : t[n] = o;
var e = (t, n, o) => (C(t, typeof n != "symbol" ? n + "" : n, o), o);
import { HubConnectionBuilder as u } from "@microsoft/signalr";
class R {
  /**
   * Creates a new SignalRHub.
   * @param hubUrl The URL of the SignalR hub. Either the full URL or an object containing the `baseUrl` and the `queryParams` which will be constructed into the full URL.
   * @param token The HTTP Bearer token for the hub.
   * @param methods The method handlers to be registered that will be invoked when the hub method with the specified method name is invoked.
   * @param connectionEventHandlers Callback handlers used to watch the SignalR connection lifecycle events.
   */
  constructor(n, o, h, l) {
    e(this, "connection");
    e(this, "connectionEventHandlers");
    e(this, "isStopping", !1);
    e(this, "handleConnectionLost", (...n) => {
      var o;
      (o = this.connectionEventHandlers) != null && o.onConnectionLost && this.connectionEventHandlers.onConnectionLost(...n);
    });
    e(this, "handleConnectionRestored", (...n) => {
      var o;
      (o = this.connectionEventHandlers) != null && o.onConnectionRestored && this.connectionEventHandlers.onConnectionRestored(...n);
    });
    e(this, "handleClose", (...n) => {
      var o;
      (o = this.connectionEventHandlers) != null && o.onConnectionRestoreFailed && this.isStopping && this.connectionEventHandlers.onConnectionRestoreFailed(...n);
    });
    let i;
    if (typeof n == "string")
      i = n;
    else {
      const { baseUrl: s, queryParams: c } = n, a = Object.entries(c).map(([d, r]) => `${encodeURIComponent(d)}=${Array.isArray(r) ? r.map(encodeURIComponent).join(",") : encodeURIComponent(r)}`).join("&");
      i = `${s}?${a}`;
    }
    this.connection = new u().withUrl(i, { accessTokenFactory: o ? () => o : void 0 }).withAutomaticReconnect([0, ...Array(12).fill(5e3)]).build(), h.forEach(({ name: s, handler: c }) => this.connection.on(s, c)), this.connectionEventHandlers = l, this.connection.onreconnecting(this.handleConnectionLost), this.connection.onreconnected(this.handleConnectionRestored), this.connection.onclose(this.handleClose);
  }
  get state() {
    return this.connection.state;
  }
  start() {
    return this.isStopping = !1, this.connection.start();
  }
  stop() {
    return this.isStopping = !0, this.connection.stop();
  }
  send(n, o) {
    return o !== void 0 ? this.connection.send(n, o) : this.connection.send(n);
  }
  invoke(n, o) {
    return o !== void 0 ? this.connection.invoke(n, o) : this.connection.invoke(n);
  }
}
export {
  R as S
};
//# sourceMappingURL=signalrHub-BGmnuXQk.js.map
